import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { CommonMessageService } from '../../services/common-message.service';
import Swal from 'sweetalert2';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-manage-announcement',
  templateUrl: './manage-announcement.component.html',
  styleUrls: ['./manage-announcement.component.css']
})
export class ManageAnnouncementComponent implements OnInit {

  @ViewChild("selectFile") selectFile;
  htmlContent;
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    // toolbarHiddenButtons: [
    //   ['bold']
    //   ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };
  minDate: { year: number, month: number, day: number };
  announcementForm: FormGroup;
  announcementList = [];
  announcementHistoryList = [];
  Submitted = false;
  imageUploadValue = false;
  fileToUpload: File = null;
  filename;
  pathName;
  hideAddNewAnnouncement = false;
  modalStatus;
  editAnnouncementId;
  choosenFileName;
  choosenFileType;
  imgURL: any;
  viewImageSrcStatus;
  viewAnyFileStatus;
  userId;
  fromDate;
  toDate;
  menuList: any;
  allowedComponents = new Set<string>();

  constructor(
    private organizationSetupService: OrganizationSetupService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private commonMessageService: CommonMessageService
  ) {
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  ngOnInit(): void {
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
      menu.menu?.menuComponents?.forEach(component => {
        this.allowedComponents.add(component.name);
      });
    });
    this.userId = localStorage.getItem('id');
    console.log('userId announcement', this.userId);
    this.viewImageSrcStatus = false;
    this.viewAnyFileStatus = false;
    // if (localStorage.getItem('announcementRoles') == 'HR' ||
    //   localStorage.getItem('announcementRoles') == 'Partner') {
    //   this.hideAddNewAnnouncement = true;
    // } else {
    //   this.hideAddNewAnnouncement = false;
    // }
    this.initModalForm();
    this.getAnnouncementDetails();
  }

  hasAccess(componentName: string): boolean {
    return this.allowedComponents.has(componentName);
  }

  initModalForm() {
    this.announcementForm = this.fb.group({
      id: [''],
      announcement: ['', [Validators.required]],
      details: ['', [Validators.required]],
      expireDate: ['', [Validators.required]],
      announcementUrl: [''],
      imageUrl: [''],
      hasAttachment: ['']
    });
  }

  onModalClick(modalContent) {
    console.log('modal content', modalContent);
    this.modalStatus = 'add';
    this.formData = null;
    this.imageUploadValue = false
    this.openModal(modalContent);
  }

  openModal(content) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(content, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  fileList: FileList;
  formData: FormData;
  isFileValid = false;
  fileChange(files) {
    var choosenFileExtension;
    this.imageUploadValue = true;
    this.fileList = files;
    if (this.fileList.length > 0) {
      let file: File = this.fileList[0];
      this.formData = new FormData();
      this.formData.append('file', file, file.name);
      console.log('file details', file.name);
      choosenFileExtension = file.name.split('.').pop();
      this.choosenFileName = file.name;
      console.log('choosenFileExtension', choosenFileExtension);
    }
    //For set image
    if (choosenFileExtension == 'jpg' || choosenFileExtension == 'jpeg' || choosenFileExtension == 'png') {
      this.viewImageSrcStatus = true;
      this.viewAnyFileStatus = false;
      var reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
        console.log('image URl', this.imgURL);
      }
    } else {
      this.viewImageSrcStatus = false;
      this.viewAnyFileStatus = true;
      // this.imgURL = "";
    }
  }

  onSaveClick() {
    console.log('forma image data', this.formData);
    this.announcementForm.controls['announcement'].markAsTouched();
    this.announcementForm.controls['details'].markAsTouched();
    this.announcementForm.controls['expireDate'].markAsTouched();
    console.log('this.announcementForm.valid', this.announcementForm.valid);
    if (this.announcementForm.valid) {
      this.organizationSetupService.createAnnouncement(this.setAnnouncementFormJSON())
        .subscribe(res => {
          console.log('response', res);
          console.log('file choosen or not', this.imageUploadValue);
          console.log('announceid', res.announcementId);
          if (this.imageUploadValue) {
            this.organizationSetupService.createImageForAnnouncemnt(this.formData, this.imageUploadValue, res.announcementId)
              .subscribe(res => {
                console.log('responseimage', res);
                this.imageUploadValue = false;
                this.closeModel();
                this.commonMessageService.swalAlertWithIcon('', 'Saved Successfully!', 'success');
              });
          } else {
            this.imageUploadValue = false;
            this.closeModel();
            this.commonMessageService.swalAlertWithIcon('', 'Saved Successfully!', 'success');
          }
        });
    }
  }

  setAnnouncementFormJSON() {
    var expireDate = new Date(this.announcementForm.value.expireDate.year + '-'
      + this.announcementForm.value.expireDate.month + '-'
      + this.announcementForm.value.expireDate.day);

    var newDate = moment(expireDate).format('YYYY-MM-DD');
    var data = {
      'id': this.announcementForm.value.id,
      'announcementName': this.announcementForm.value.announcement,
      'announcementUrl': this.announcementForm.value.announcementUrl,
      'announcementDetails': this.announcementForm.value.details,
      'expiryDate': newDate,
      'hasAttachment': this.imageUploadValue,
      // 'imageUrl': this.announcementForm.value.imageUrl
    };
    console.log('data', data);
    return JSON.stringify(data);
  }

  closeModel() {
    this.announcementHistoryList = [];
    this.ngOnInit();
    this.announcementForm.reset();
    this.modalService.dismissAll();
  }

  getAnnouncementDetails() {
    this.organizationSetupService.getAnnouncement()
      .subscribe((res: any) => {
        this.announcementList = res;
        console.log('announcement list', this.announcementList);

        for (let i = 0; i < this.announcementList.length; i++) {
          if (this.announcementList[i].url != null) {
            this.filename = this.announcementList[i].url.replace(/^.*[\\\/]/, '')
            var extension = this.announcementList[i].url.split('.').pop();
            this.announcementList[i]["fileType"] = extension;
            this.announcementList[i]["imageName"] = this.filename;
          }
        }

        console.log('agfter adding file announcement list', this.announcementList);

      });
  }


  onEditClick(announceDetail, modalContent) {
    this.modalStatus = 'edit';
    this.viewImageSrcStatus = false;
    this.viewAnyFileStatus = false;
    this.editAnnouncementId = announceDetail.id;

    var formatDate = moment(announceDetail.expiryDate, 'YYYY/MM/DD');
    this.announcementForm.patchValue({
      id: announceDetail.id,
      announcement: announceDetail.announcementName,
      details: announceDetail.announcementDetails,
      announcementUrl: announceDetail.announcementUrl,
      expireDate: { year: parseInt(formatDate.format('YYYY')), month: parseInt(formatDate.format('M')), day: parseInt(formatDate.format('D')) },
      // imageUrl: announceDetail.url
    });
    console.log('announcement  form', announceDetail);
    this.imgURL = announceDetail.url;
    this.choosenFileName = announceDetail.imageName;
    this.choosenFileType = announceDetail.fileType;

    if (this.choosenFileType == 'jpg' || this.choosenFileType == 'jpeg' || this.choosenFileType == 'png') {
      this.viewImageSrcStatus = true;
    } else if (this.choosenFileType == undefined) {
      this.viewAnyFileStatus = false;
      this.viewImageSrcStatus = false;
    } else {
      this.viewAnyFileStatus = true;
    }
    this.openModal(modalContent);
  }


  onUpdateClick() {
    this.announcementForm.controls['announcement'].markAsTouched();
    this.announcementForm.controls['details'].markAsTouched();
    this.announcementForm.controls['expireDate'].markAsTouched();
    if (this.announcementForm.valid) {
      this.organizationSetupService.updateAnnouncement(this.setAnnouncementFormJSON())
        .subscribe(res => {
          console.log('response', res);
          console.log('file choosen or not', this.imageUploadValue);
          if (this.imageUploadValue) {
            this.organizationSetupService.updateImageForAnnouncemnt(this.formData, this.editAnnouncementId)
              .subscribe(res => {
                console.log('responseimage', res);
                this.imageUploadValue = false;
                this.closeModel();
                this.commonMessageService.swalAlertWithIcon('', 'Updated Successfully!', 'success');
              });
          } else {
            console.log('imageUploadValue', this.imageUploadValue);
            this.imageUploadValue = false;
            this.closeModel();
            this.commonMessageService.swalAlertWithIcon('', 'Updated Successfully!', 'success');
          }
        });
    }
  }

  onDeleteClick(announceDetail) {
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: '#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.organizationSetupService.deleteAnnouncement(announceDetail.id)
          .subscribe(res => {
            console.log('delete announcement');
          });
        this.closeModel();
        this.commonMessageService.swalAlertWithIcon('', 'Deleted Successfully!', 'success');
      }
    })
  }

  openHistoryModal(content) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'xl',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(content, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  onHistoryModalClick(modalContent) {
    this.openHistoryModal(modalContent);
  }

  onFromDateChange(fromDate) {
    var formatFromDate = new Date(fromDate.year + '-' + fromDate.month + '-' + fromDate.day);
    this.fromDate = moment(formatFromDate).format('YYYY-MM-DD');
    console.log('fromDate', this.fromDate);
  }

  onToDateChange(toDate) {
    var FormatToDate = new Date(toDate.year + '-' + toDate.month + '-' + toDate.day);
    this.toDate = moment(FormatToDate).format('YYYY-MM-DD');
    console.log('toDate', this.toDate);
  }

  onClickViewDetails() {
    this.organizationSetupService.getAnnouncementHistory(this.fromDate, this.toDate).subscribe((res: any) => {
      console.log('history res', res);
      this.announcementHistoryList = res;
    })
  }
}
